import { useEffect, useState } from 'react'
import moment from 'moment'
import { ActiveMinutes } from '@dialogue/services'
import type { Challenge } from '@dialogue/services/dist/active-minutes/model'

const pad = (value: number) => (value < 10 ? `0${value}` : `${value}`)
const formatCountdown = (time: moment.Duration) =>
  `${pad(Math.floor(time.asDays()))} : ${pad(time.hours())} : ${pad(time.minutes())} : ${pad(
    time.seconds()
  )}`

const useActiveMinutesCountdown = (challenge: Challenge | null | undefined) => {
  const [countdown, setCountdown] = useState('')

  useEffect(() => {
    let intervalCall: ReturnType<typeof setInterval> | undefined

    if (!challenge || challenge.status !== ActiveMinutes.Types.ChallengeStatus.Ongoing) {
      setCountdown('')
      return
    }

    const endDate = moment.utc(challenge.ends_at).valueOf()

    const updateCountdown = () => {
      const remaining = endDate - Date.now()

      if (remaining <= 0) {
        setCountdown('')
        clearInterval(intervalCall)
        return
      }

      setCountdown(formatCountdown(moment.duration(remaining, 'milliseconds')))
    }

    updateCountdown()
    intervalCall = setInterval(updateCountdown, 1000)

    return () => {
      clearInterval(intervalCall)
    }
  }, [challenge])

  return countdown
}

export default useActiveMinutesCountdown
